export default {
  router: {
    dashboard: '首頁',
    introduction: '简述',
    documentation: '文档',
    permission: '權限测试頁',
    icons: '图标'
  },
  route: {
    dashboard: '首頁',
    introduction: '简述',
    documentation: '文档',
    permission: '權限测试頁',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    tinymce: '富文本編輯器',
    markdown: 'Markdown',
    jsonEditor: 'JSON編輯器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合實例',
    Table: 'Table',
    dynamicTable: '动态Table',
    dragTable: '拖拽Table',
    inlineEditTable: 'Table內編輯',
    complexTable: '综合Table',
    treeTable: '树形表格',
    customTreeTable: '自定义树表',
    tab: 'Tab',
    form: '表單',
    createForm: '創建表單',
    editForm: '編輯表單',
    errorPages: '错误頁面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化'
  },
  navbar: {
    logOut: '退出登錄',
    dashboard: '首頁',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤'
  },
  login: {
    title: '系統登錄',
    logIn: '登錄',
    username: '账號',
    password: '密碼',
    any: '随便填',
    thirdparty: '第三方登錄',
    thirdpartyTips: '本地不能模拟，請结合自己業務进行模拟！！！'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    roles: '你的權限',
    switchRoles: '切换權限'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一個核心的功能，但同时又是一個有很多坑的地方。在選擇富文本的過程中我也走了不少的弯路，市面上常见的富文本都基本用過了，最终權衡了一下選擇了Tinymce。更詳细的富文本比较和介绍见',
    dropzoneTips: '由於我司業務有特殊需求，而且要传七牛 所以没用第三方，選擇了自己封装。代碼非常的简單，具體代碼你可以在这里看到 @/components/Dropzone',
    stickyTips: '当頁面滚动到预設的位置会吸附在顶部',
    backToTopTips1: '頁面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由於我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照點击顺序排序',
    dragTips1: '默認顺序',
    dragTips2: '拖拽后顺序',
    title: '標題',
    importance: '重要性',
    type: '類型',
    remark: '點评',
    search: '搜索',
    add: '添加',
    export: '導出',
    reviewer: '审核人',
    id: '序號',
    date: '時間',
    author: '作者',
    readings: '阅读數',
    status: '狀態',
    actions: '操作',
    edit: '編輯',
    publish: '發布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '確 定'
  },
  errorLog: {
    tips: '請點击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用戶體验，但同时也会增加頁面出问题的可能性，可能一個小小的疏忽就導致整個頁面的死锁。好在 Vue 官网提供了一個方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '導出',
    selectedExport: '導出已選擇项',
    placeholder: '請输入文件名(默認excel-list)'
  },
  zip: {
    export: '導出',
    placeholder: '請输入文件名(默認file)'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它區别於 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的應用场景，具體請参考文档。'
  }
}
